// Universal slot color scheme across player/admin/manager views.
// Free       → white / light slate (default actionable)
// Selected   → light blue (sky)
// Booked     → green  (real player booking — already sold)
// Blocked    → grey   (admin/manager hold or maintenance)
// Unavailable→ same as blocked (cannot pick)

export function slotClass({ booked = false, isBlock = false, selected = false, disabled = false, external = false } = {}) {
    if (selected) {
        return "bg-sky-400 text-slate-950 border-sky-300 shadow-[0_0_0_2px_rgba(56,189,248,0.35)]";
    }
    if (isBlock) {
        return "bg-slate-600/40 text-slate-300 border-slate-600 cursor-pointer";
    }
    if (booked && external) {
        // Orange — only shown to admin/manager when the booking originated from a 3rd-party app (Hudle/Playo).
        return "bg-orange-500/25 text-orange-300 border-orange-500/60 cursor-not-allowed";
    }
    if (booked) {
        return "bg-[#00FF66]/25 text-[#00FF66] border-[#00FF66]/50 cursor-not-allowed";
    }
    if (disabled) {
        return "bg-slate-800/60 text-slate-600 border-slate-800 cursor-not-allowed opacity-60";
    }
    // Free
    return "bg-white text-slate-900 border-slate-200 hover:border-sky-400";
}

export const SLOT_LEGEND = [
    { label: "Free", swatch: "bg-white border border-slate-300" },
    { label: "Selected", swatch: "bg-sky-400" },
    { label: "Booked", swatch: "bg-[#00FF66]/40 border border-[#00FF66]/60" },
    { label: "Blocked", swatch: "bg-slate-600/60 border border-slate-500" },
];

// Extended legend for admin/manager — adds the orange "External (Other App)" swatch.
export const SLOT_LEGEND_STAFF = [
    ...SLOT_LEGEND,
    { label: "Other App", swatch: "bg-orange-500/40 border border-orange-500/60" },
];
